export const mobile = 760
export const tablet = 1040